import type { PortalNotification } from './notificationHref';
import { getBaseQuotationNo } from '../utils/quotationRevision.ts';

export const isDocumentUpload = (notification: PortalNotification): boolean =>
  notification.type === 'customer_document_uploaded';

export function documentNotificationDisplay(notification: PortalNotification): { title: string; message: string } {
  if (!isDocumentUpload(notification)) return { title: notification.title, message: notification.message };
  const names = notification.metadata?.uploaded_document_names ?? [];
  return {
    title: 'Documents received',
    message: names.length ? `All requested documents received: ${names.join(', ')}` : notification.message,
  };
}

/** Uploaded documents are shared by the quotation's revision chain. */
export function matchesDocumentQuotation(notification: PortalNotification, quotationNo: string): boolean {
  return isDocumentUpload(notification) && !!quotationNo && !!notification.quotation_no
    && getBaseQuotationNo(quotationNo) === getBaseQuotationNo(notification.quotation_no);
}

export function showDocumentPopup(notification: PortalNotification, source: string, pathname: string, search: string): boolean {
  return source === 'live'
    && pathname.replace(/\/$/, '') === '/dashboard/products/motor/documentation'
    && matchesDocumentQuotation(notification, new URLSearchParams(search).get('quotationNo') ?? '');
}

/** Public document slugs normally mirror storage columns, except registration. */
export function documentNotificationColumn(notification: PortalNotification): string | null {
  if (!isDocumentUpload(notification)) return null;
  const slug = notification.metadata?.document_type;
  if (!slug) return null;
  return slug === 'vehicle-registration-certificate' ? 'vehicle_regist_certificate' : slug.replace(/-/g, '_');
}
